import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import React, { useEffect } from "react";

const BankValidationPopup = ({
  openWarningModal,
  setOpenWarningModal,
  aadharDetails,
  bankDetails,
  setDocRejectModal,
  docId,
  bankErrorMessage,
  setFormId,
  candidateDetails,
}) => {
  let accountName = "";
  let aadharName = "";

  if (bankDetails?.aadharVerificationDetails) {
    const { aadharVerificationDetails } = bankDetails;
    const { data, success } = aadharVerificationDetails;
    if (data && success) {
      const { full_name } = data;
      accountName = full_name;
    }
  }

  if (aadharDetails?.aadharVerificationDetails) {
    const { aadharVerificationDetails } = aadharDetails;
    const { data, success } = aadharVerificationDetails;
    if (data && success) {
      const { full_name } = data;
      aadharName = full_name;
    }
  }

  const Name = candidateDetails?.name
    ? candidateDetails.name
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : "";

  useEffect(() => {
    if (docId) {
      setFormId(docId);
    }
  }, [docId]);

  return (
    <Modal
      title=""
      className="p-0 custom_modal__"
      centered
      closable={null}
      open={openWarningModal}
      width={600}
      closeIcon={null}
      footer={null}
    >
      <div>
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
          <h5
            className="modal-title text-white text-capitalize font-weight-bold"
            style={{ fontSize: "18px", fontWeight: 400 }}
          >
            Alert
          </h5>
        </div>
        <div className="row py-3 px-4 ">
          <div className="w-100">
            <div className="col-12 p-3">
              <div className="d-flex __custom_row">
                <div style={{ flex: "1 1", width: "100%" }}>
                  <h4
                    className="__custom_heading text-center"
                    style={{ marginTop: "1rem" }}
                  >
                    Alert
                  </h4>
                  <p
                    className="font-weight-bold text-danger"
                    style={{ marginTop: "1.6rem", textAlign: "center" }}
                  >
                    {bankErrorMessage}
                  </p>
                  <div
                    className="d-flex justify-content-center gap-1"
                    style={{
                      marginTop: "2.1rem",
                      paddingBottom: "2.1rem",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    <button
                      className={`__btn px-3 text-white rounded font-weight-bold __initial_accepted`}
                      onClick={async () => {
                        setOpenWarningModal(false);
                      }}
                    >
                      {" "}
                      <CheckOutlined
                        style={{
                          borderRadius: "50%",
                          padding: 2,
                          marginRight: "5px",
                        }}
                        className={"__initial_accepted_icon"}
                      />
                      Proceed Anyway
                    </button>
                    <button
                      className={`__btn px-3 text-white rounded font-weight-bold __initial_rejected`}
                      onClick={(e) => setDocRejectModal(true)}
                    >
                      <CloseOutlined
                        style={{
                          borderRadius: "50%",
                          padding: 2,
                          marginRight: "5px",
                        }}
                        className={"__initial_rejected_icon"}
                      />
                      Reject
                    </button>
                  </div>
                  <div className="px-2 mb-2">
                    <div className="mt-2">
                      <div style={{ textTransform: "capitalize" }}>
                        Candidate Name :{" "}
                        <strong>{aadharName || Name || "Not Found"}</strong>
                      </div>
                      <div style={{ textTransform: "capitalize" }}>
                        Account Holder Name :{" "}
                        <strong>{accountName || "Not Found"}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BankValidationPopup;
